module.exports = __webpack_public_path__ + "img/logo.ed2447cf.webp";